/**
 * disconnect-upstream-message.ts
 * Copyright © 2016-2018, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { MessageTag } from "../message-tag";

/**
 * The client sends an {@link DisconnectUpstreamMessage} to end the connection,
 * either as an acknowledgement that the server is in a DISCONNECTING state, or
 * to signal that the socket is closing due to user or program action.
 */
export class DisconnectUpstreamMessage extends Message
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.UP_DISCONNECT;
	public static tag : MessageTag = MessageTag.UP_DISCONNECT;

  public expectsReply () : boolean
  {
    return false;
  }

  /**
   * Construct a new {@link DisconnectUpstreamMessage}.
   */
  constructor (public id : number = 0)
  {
    super();
  }
}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/auth/disconnect-upstream-message.ts